import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@xem/look/Renders/Field";
import countries from "@gqlapp/config/country/countries";
import countryToPath from '@xem/entity/classes/countryToPath';

export default (function Country(props){
	let { id: name, site, name: label, values, required, onActions, setFieldValue  } = props || {}

	// debug('#### View site', site);

	let value = values[name];
	value = value || site?.country;
	if(value === '-'){
		value = 'VN';
	}

	// debug('#### View country', value);
	const onClick = (e)=>{
		e && e.preventDefault && e.preventDefault();
		onActions && onActions?.country && onActions.country({
			title: 'page:popup.country'.t(),
			country: value,
			onChange: (value) => setFieldValue(name, value)
		})
	}

	let country = [...countries].filter(({ value: v })=> (value === v))
	country = (country || []).shift();
	let valueLabel = country?.label;

	return <>
		<Field
			{...{ onClick, component: RenderField }}
			{...{ className: 'Mui-textfield', label, name, value: valueLabel, required }}
			{...{ arrowIcon: { arrowProps:{ onClick } } }}
			{...{
				prefix: (!value)? null: <>{countryToPath(value)}</>,
				sx: {
					'& .endAdornment':{
						zIndex: 10,
						position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
						cursor: 'pointer',
						'&> div, &> div > .btn':{
							width: '100% !important',
							height: '100% !important',
						},
						'&> div > .btn':{
							textAlign: 'right',
							paddingRight: '10px !important'
						}
					}
				}
			}}
		/>
	</>
})